import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '../../../common/html/icon'
import { Loading } from '../../../common/loading'
import { Panel } from '../../../common/panel'
import { PanelContainer } from '../../../common/panel/PanelContainer'
import { Tooltip } from '../../../common/tooltip'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE, USER_TYPE } from '../../../utils/authorization'
import { PANELS } from '../constant'
import {
  changePanelId,
  selectLoading,
  selectPanelById,
  selectPanelId,
} from '../store/slice'
import { ViewDetails } from './ViewDetails'
import { getContentPanel } from './helper'

export const Panels = ({ setIsShowPreferenceSetting }) => {
  const dispatch = useDispatch()

  const loading = useSelector(selectLoading('defaultTemplateForLayout'))
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const changeLayout = (data) => {
    dispatch(changePanelId(data.map((panel) => panel.id)))
  }

  const handleAddNewPanel = () => {
    setIsShowPreferenceSetting(true)
  }

  const renderLabel = (item) => {
    if (
      [PANELS.TOP_INDUSTRY_PLAYERS, PANELS.TOP_COMPARABLE_PLAYERS].includes(
        item.key,
      )
    ) {
      return (
        <Tooltip
          tooltipContent={
            item.key === PANELS.TOP_COMPARABLE_PLAYERS
              ? 'companySummary.topComparablePlayers.TOOLTIP_TITLE'
              : 'companySummary.topIndustryPlayers.TOOLTIP_TITLE'
          }
          translateProps={{ dangerousHTML: true }}
          isI18n
          contentClass="ml1 dFlex"
          tooltipContentStyle={{ maxWidth: 500 }}
        >
          <Icon
            className="icon-info-circle"
            style={{ color: '#9C9C9C', fontSize: 16 }}
          />
        </Tooltip>
      )
    } else {
      return null
    }
  }

  if (loading) {
    return <Loading />
  }

  const isDisable =
    AUTHORIZATION_API.companyAnalysis.preferenceSettings[
      userType.userTypeId
    ] === AUTHORIZATION_TYPE.DISABLE

  return (
    <PanelContainer
      key={panelId.length}
      changeLayout={changeLayout}
      isAllowDragDrop
      handleAddNewPanel={handleAddNewPanel}
    >
      {panelId
        .filter(
          (key) =>
            !(
              userType.userTypeId === USER_TYPE.STANDARD &&
              panelById[key].key === PANELS.SCORE
            ),
        )
        .map((id, index) => {
          const item = panelById[id]

          if (!item) {
            return <Fragment key={index} />
          }

          const isComparablePlayer = item.key === PANELS.TOP_COMPARABLE_PLAYERS
          const isAllowDragDrop =
            !isDisable &&
            (!isComparablePlayer || userType.userTypeId === USER_TYPE.PREMIUM)

          return (
            <Panel
              key={id}
              label={item.label}
              isI18n
              renderLabel={() => renderLabel(item)}
              renderRightHeader={() =>
                (!isComparablePlayer ||
                  [USER_TYPE.PREMIUM, USER_TYPE.STANDARD].includes(
                    userType.userTypeId,
                  )) && <ViewDetails id={item.key} />
              }
              type={item.type}
              id={item.id}
              className={item.key}
              changeLayout={changeLayout}
              isAllowDragDrop={isAllowDragDrop}
              height={
                item.key === PANELS.COMPANY_OVERVIEW
                  ? undefined
                  : isComparablePlayer
                  ? 366
                  : 332
              }
            >
              {getContentPanel(item.key, item.type)}
            </Panel>
          )
        })}
    </PanelContainer>
  )
}

Panels.propTypes = {
  setIsShowPreferenceSetting: PropTypes.func.isRequired,
}
